export default __webpack_public_path__ + "static/footer_logo-a5a7dbd710b491d1c155ee26a58b89aa.svg";